import React, { useCallback } from 'react';
import type { Alert } from '#/graphql/types';
import { useNavigate } from 'react-router-dom';
import List from '#/common/components/List';
import { gql } from '@apollo/client';
import { columns } from '../AlertDataGrid/columns';
import { getAlertList } from '#/graphql/queries';
import { alertStateColors, states } from '../../utils/constants';
import { withChip } from '#/common/utils/wrappers';

const getAlertListQuery = gql(getAlertList);

const AlertList: React.FC = () => {
  const navigate = useNavigate();

  const openAlert = useCallback(
    (alert: Alert) => {
      navigate(`/alerts/${alert.id}`);
    },
    [navigate],
  );

  return (
    <List<Alert>
      titleKey="exceptionName"
      subtitleKey="displayNumber"
      onClick={openAlert}
      getItemsQuery={getAlertListQuery}
      bodyFields={[
        { key: 'asset.assetTag', label: 'Device Name' },
        { key: 'lastException', label: 'Latest Exception Date' },
      ]}
      customChip={(item: Alert) => {
        const stateLabel = states[item.state as keyof typeof states]?.text || '';
        const stateColors = item.state ? alertStateColors[item.state as string] : undefined;
        return item.state ? withChip(stateLabel, 'normal', stateColors) : null;
      }}
      columnList={columns}
    />
  );
};

export default React.memo(AlertList);
